import React from 'react'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import Modal from './Modal'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '../index.css'
import ToolChartAnalysis from '../assets/images/ToolChartAnalysis.png'
import ToolClassRecording from '../assets/images/ToolClassRecording.png'
import ToolCodeEditor from '../assets/images/ToolCodeEditor.png'
import ToolDocumentEditor from '../assets/images/ToolDocumentEditor.png'
import ToolVectorialDesign from '../assets/images/ToolVectorialDesign.png'
import ToolVideoConference from '../assets/images/ToolVideoConference.png'
import ToolWebBrowser from '../assets/images/ToolWebBrowser.png'
import ToolWhiteboard from '../assets/images/ToolWhiteboard.png'
import Footer from './Footer'
const CarouselTools = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false) // State to handle Modal visibility

  const handleModalOpen = () => {
    setIsModalOpen(true)
    setIsMobileMenuOpen(false) // Close the mobile menu when opening modal
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const toolsData = [
    {
      id: 1,
      title: 'Advanced Video Conference',
      description: `
        Experience hassle-free video communication during your crypto classes
        with our seamless on-platform services. Our advanced Video Conference
        system takes care of everything - no need to download apps or plug-ins.
        Everything is embedded on Apolo, making it a unique user-friendly experience.
        Our aim is to deliver seamless video conferencing features so that your focus
        is never interrupted with technical issues. These high-tech features enable
        faster learning so that you are constantly interested!
      `,
      imageAlt: 'Advanced Video Conference',
      imageSrc: ToolVideoConference,
    },
    {
      id: 2,
      title: 'Collaborative Whiteboard',
      description: `
        Our crypto tutoring website offers an unparalleled learning experience
        that goes beyond a video call. All our classes are much more than just a
        video conference between a student and a tutor. Our Whiteboard allows
        you to make tutoring more interactive by highlighting the most important
        information and visualizing everything for a more impactful lecture.
        This is not just a one-way tool, but students and tutors both use it to
        engage in two-way questions, collaborate on case studies, and explore other
        class material.
      `,
      imageAlt: 'Collaborative Whiteboard',
      imageSrc: ToolWhiteboard,
    },
    {
      id: 3,
      title: 'Collaborative Web Browser',
      description: `
        Discover our platform's shared web browser feature. Both tutors and
        students can simultaneously navigate the web together, accessing a
        diverse array of knowledge and content in real-time. Collaborate seamlessly
        with your tutor as you explore topics such as cryptocurrency and blockchain
        technology. Additionally, utilize this feature to export real-world cases directly
        to the whiteboard with your classes, enhancing your collaborative learning
        experience.
      `,
      imageAlt: 'Collaborative Web Browser',
      imageSrc: ToolWebBrowser,
    },
    {
      id: 4,
      title: 'Collaborative Advanced Code Editor',
      description: `
        Incorporating various tools directly within the class, Apolo streamlines
        your learning experience. Activate our collaborative code editor seamlessly
        within the same interface, eliminating the need to switch between different
        services. Tailored for blockchain and smart contract development, this feature
        empowers you to enhance your coding skills alongside your tutor in
        real-time.
      `,
      imageAlt: 'Collaborative Advanced Code Editor',
      imageSrc: ToolCodeEditor,
    },
    {
      id: 5,
      title: 'Collaborative Chart Analysis',
      description: `
        Access our specialized chart analysis tool seamlessly within your class.
        Analyze market trends, customize charts, and learn how to use markers,
        indicators, and other tools, helping you make informed decisions based
        on real-time market data, all without leaving the platform. Collaborate
        effortlessly with your tutor using the chart analysis tool to
        develop effective trading strategies tailored to your class material.
      `,
      imageAlt: 'Collaborative Chart Analysis',
      imageSrc: ToolChartAnalysis,
    },
    {
      id: 6,
      title: 'Collaborative Document Editor',
      description: `
        Apolo provides a shared document editor accessible to both tutors and
        students during classes. This editor is specifically tailored for crafting
        various texts, including articles, essays, and whitepapers focused on
        blockchain, DAOs, and DeFi services. Seamlessly collaborate on the same
        document, exchanging ideas and refining content without the need for
        external tools or software.
      `,
      imageAlt: 'Collaborative Document Editor',
      imageSrc: ToolDocumentEditor,
    },
    {
      id: 7,
      title: 'Collaborative Vectorial Design',
      description: `
        Explore digital art like never before! Discover our integrated vectorial
        design tool tailored for digital art classes. Collaborate in real-time
        with tutors using our on-platform vectorial software, helping you learn
        how to create digital artwork together. This tool offers collaborative
        design features, ensuring the knowledge you develop here can easily
        enhance your digital artist skills.
      `,
      imageAlt: 'Collaborative Vectorial Design',
      imageSrc: ToolVectorialDesign,
    },
    {
      id: 8,
      title: 'Class Recording',
      description: `
        At Apolo, we prioritize flexibility in learning. With our class recording
        feature, students have the ability to record every session, ensuring full
        access to course content whenever needed. Never worry about missing important
        information again. Apolo empowers you to learn at your own pace, whether
        you need to revisit challenging topics or refine key concepts you can access
        classes anytime.
      `,
      imageAlt: 'Class Recording',
      imageSrc: ToolClassRecording,
    },
  ]

  return (
    <>
      <section className="Tools min-h-[700px]">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true} // Enable infinite looping
          className="Tools-Carousel"
          style={{ padding: '0 20px' }} // Add padding around the Swiper
        >
          {toolsData.map((tool) => (
            <SwiperSlide key={tool.id}>
              <div className="Tools-item">
                <img src={tool.imageSrc} alt={tool.imageAlt} className="Tools-image" />
                <div className="Tools-text">
                  <h2>{tool.title}</h2>
                  <p>{tool.description}</p>
                  <div className="Tools-buttons">
                    <button
                      onClick={handleModalOpen}
                      className="cta-button"
                      style={{ marginBottom: 25 }}
                    >
                      Become a Tutor
                    </button>
                    <button onClick={handleModalOpen} className="cta-button">
                      Become a Student
                    </button>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {isModalOpen && <Modal onClose={handleModalClose} />}
      </section>
    </>
  )
}
export default CarouselTools
